import React from "react";
import { MdOutlineRestartAlt } from "react-icons/md";
import { Button, message } from "antd";
import { useCreate } from "@refinedev/core";

type Props = {
  taskId: string;
  onDone: () => void;
  disabled?: boolean;
};

function ButtonRestartTask({ taskId, onDone, disabled }: Props) {
  const { mutateAsync, isLoading } = useCreate({});
  const [messageApi, contextHolder] = message.useMessage();

  const handleRestartTask = async () => {
    try {
      await mutateAsync(
        {
          dataProviderName: "defaultV2",
          resource: `audio-tasks/${taskId}/restart`,
          values: {},
          successNotification: false,
          errorNotification: false,
        },
        {
          onSuccess: () => {
            messageApi.success("Restart task successfully");
            onDone();
          },
          onError: (error) => {
            messageApi.error(error.message);
          },
        }
      );
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Button
      size="small"
      loading={isLoading}
      onClick={handleRestartTask}
      disabled={disabled}
      icon={
        <MdOutlineRestartAlt
          style={{
            padding: 0,
            margin: 0,
          }}
        />
      }
    />
  );
}

export default ButtonRestartTask;
